module.exports = __webpack_public_path__ + "img/shopback_pay.cc63beaa.png";